import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import env from "../services/env";

// Renders an admin-managed page (Admin > Pages) at /page/:slug.
function CmsPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, page: null });

  useEffect(() => {
    let active = true;
    setState({ loading: true, page: null });
    fetch(`${env.url}/pages/${encodeURIComponent(slug)}`, { headers: { Accept: "application/json" } })
      .then((res) => (res.ok ? res.json() : null))
      .then((res) => active && setState({ loading: false, page: res?.data || null }))
      .catch(() => active && setState({ loading: false, page: null }));
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <>
      <Header />
      <main className="max-w-screen-lg mx-auto px-4 py-12 min-h-[50vh]">
        {state.loading && <p>Loading...</p>}
        {!state.loading && !state.page && <p>Page not found.</p>}
        {state.page && (
          <>
            <h1 className="text-3xl font-bold mb-6">{state.page.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: state.page.content }} />
          </>
        )}
      </main>
      <Footer />
    </>
  );
}

export default CmsPage;
